export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/get-on-app-store.b96c9339.svg","height":33,"width":99,"blurWidth":0,"blurHeight":0};